import { Reducer } from 'redux';
import { EmployeesSalesState, EmployeesSalesTypes } from './types';

const INITIAL_STATE: EmployeesSalesState = {
  employeeData: {
    id: '',
    type: 0,
    name: '',
    phone: '',
    registry: '',
    document: '',
    licenseNumber: '',
    licenseType: '',
    licenseExpiration: '',
    licenseFrontPhoto: '',
    licenseBackPhoto: '',
    createdAt: '',
    updatedAt: '',
    testOnly: false,
    status: '',
  },
  employeesList: [],
  paymentsList: [],
  transactionsList: [],
  totalCount: 0,
  error: false,
  loading: false,
  csv: [],
};

const reducer: Reducer<EmployeesSalesState> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    // CASES LIST EMPLOYEES
    case EmployeesSalesTypes.LIST_EMPLOYEES_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        employeesList: INITIAL_STATE.employeesList,
      };
    case EmployeesSalesTypes.LIST_EMPLOYEES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        employeesList: action.payload.employeesList,
        totalCount: action.payload.totalCount,
      };
    case EmployeesSalesTypes.LIST_EMPLOYEES_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        employeesList: INITIAL_STATE.employeesList,
      };

    // CASES GET EMPLOYEE
    case EmployeesSalesTypes.GET_EMPLOYEE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        employeeData: INITIAL_STATE.employeeData,
      };
    case EmployeesSalesTypes.GET_EMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        employeeData: action.payload.employeeData,
      };
    case EmployeesSalesTypes.GET_EMPLOYEE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        employeeData: INITIAL_STATE.employeeData,
      };

    // CASES FILTER EMPLOYEES
    case EmployeesSalesTypes.FILTER_EMPLOYEES_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        employeesList: INITIAL_STATE.employeesList,
      };
    case EmployeesSalesTypes.FILTER_EMPLOYEES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        employeesList: action.payload.employeesList,
        totalCount: action.payload.totalCount,
      };
    case EmployeesSalesTypes.FILTER_EMPLOYEES_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        employeesList: INITIAL_STATE.employeesList,
      };

    // CASES GET EMPLOYEE SALES RESUME
    case EmployeesSalesTypes.GET_EMPLOYEE_SALES_RESUME_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case EmployeesSalesTypes.GET_EMPLOYEE_SALES_RESUME_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case EmployeesSalesTypes.GET_EMPLOYEE_SALES_RESUME_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CASES LIST PAYMENTS
    case EmployeesSalesTypes.LIST_PAYMENTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        paymentsList: INITIAL_STATE.paymentsList,
      };
    case EmployeesSalesTypes.LIST_PAYMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        paymentsList: action.payload.paymentsList,
      };
    case EmployeesSalesTypes.LIST_PAYMENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        paymentsList: INITIAL_STATE.paymentsList,
      };

    // CASES LIST TRANSACTIONS
    case EmployeesSalesTypes.LIST_TRANSACTIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        transactionsList: INITIAL_STATE.transactionsList,
      };
    case EmployeesSalesTypes.LIST_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        transactionsList: action.payload.transactionsList,
      };
    case EmployeesSalesTypes.LIST_TRANSACTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        transactionsList: INITIAL_STATE.transactionsList,
      };

    // CASES ADD PAYMENT EMPLOYEE
    case EmployeesSalesTypes.ADD_PAYMENT_EMPLOYEE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case EmployeesSalesTypes.ADD_PAYMENT_EMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case EmployeesSalesTypes.ADD_PAYMENT_EMPLOYEE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CASES GET EMPLOYEE SALES TRIP RESUME
    case EmployeesSalesTypes.GET_EMPLOYEE_SALES_TRIP_RESUME_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case EmployeesSalesTypes.GET_EMPLOYEE_SALES_TRIP_RESUME_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        csv: action.payload.csv,
      };
    case EmployeesSalesTypes.GET_EMPLOYEE_SALES_TRIP_RESUME_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    default:
      return state;
  }
};

export default reducer;
